import classnames from 'classnames';
import { Text } from "../../Text/Text/Text";
import { MatchHeightElement } from "../../Utility/MatchHeight/MatchHeightElement";
import styles from "./RecommendedFlag.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var RecommendedFlag = function RecommendedFlag(_ref) {
  var text = _ref.text,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_jsx("div", {
    className: styles.container,
    children: /*#__PURE__*/_jsx(MatchHeightElement, {
      valign: "center",
      flex: true,
      group: "flag",
      children: /*#__PURE__*/_jsx(Text, {
        richText: true,
        typog: 'bodycopy',
        className: classnames(styles.recommendedFlag, className),
        children: text
      })
    })
  });
};